import AllowedAccess from './AllowedAccess';

export default AllowedAccess;
